import { type Offer } from 'schema-dts'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { productAccessorGetOfferByIdOrDefault } from '../../model/productAccessor/productAccessorGetOfferByIdOrDefault'
import { productAccessorStockStatusIsAvailable } from '../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { productAccessorStockStatusIsFreebie } from '../../model/productAccessor/productAccessorStockStatusIsFreebie'

import { getEligibleQuantitySchema } from './getEligibleQuantitySchema'
import { getIsoDateForTomorrow } from './getIsoDates'

export const getOfferSchema = (
  product: PimProductV11,
  isMarketplace: boolean,
  withEligibleQuantity = false,
): Offer | undefined => {
  // Only emit Offer for products that can be ordered
  const isOrderableProduct =
    productAccessorStockStatusIsAvailable(product) ||
    productAccessorStockStatusIsFreebie(product)

  if (!isOrderableProduct) {
    return undefined
  }

  const bestOffer = productAccessorGetOfferByIdOrDefault({
    isMarketplace,
    offers: product.offers,
  })

  // about missing required Offer fields (e.g., price, priceCurrency)
  const offerPrice = bestOffer?.offerPrice?.price

  if (!offerPrice) {
    return undefined
  }

  const offerCurrency = bestOffer.offerPrice?.currency

  return {
    '@type': 'Offer',
    availability: 'https://schema.org/InStock',
    eligibleQuantity:
      withEligibleQuantity && product.package_size
        ? getEligibleQuantitySchema(product.package_size)
        : undefined,
    itemCondition: 'https://schema.org/NewCondition',
    price: offerPrice,
    priceCurrency: offerCurrency ?? 'EUR',
    priceValidUntil: getIsoDateForTomorrow(),

    url: product.canonical_url,
  }
}
